import { Type } from '@sinclair/typebox';
import { NullishType } from './standard-schema.js';
export var SupplierInvoiceStatusType;
(function (SupplierInvoiceStatusType) {
    SupplierInvoiceStatusType["UnderCertificate"] = "undercertificate";
    SupplierInvoiceStatusType["Parked"] = "parked";
    SupplierInvoiceStatusType["Disputed"] = "disputed";
    SupplierInvoiceStatusType["Approved"] = "approved";
    SupplierInvoiceStatusType["Paid"] = "paid";
    SupplierInvoiceStatusType["Credit"] = "credit";
    SupplierInvoiceStatusType["Incoming"] = "incoming";
    SupplierInvoiceStatusType["Voided"] = "voided";
})(SupplierInvoiceStatusType || (SupplierInvoiceStatusType = {}));
export var VatType;
(function (VatType) {
    VatType["None"] = "NONE";
    VatType["Normal"] = "NORMAL";
    VatType["EuInternal"] = "EUINTERNAL";
    VatType["Reverse"] = "REVERSE";
})(VatType || (VatType = {}));
export const GetSupplierInvoicesParamsSchema = Type.Object({
    projectId: Type.String(),
});
export const GetSupplierInvoicesQuerySchema = Type.Object({
    accountNumber: NullishType(Type.Number()),
    ataNumber: NullishType(Type.Number()),
    supplierId: NullishType(Type.String()),
    supplierName: NullishType(Type.String()),
    supplierOrganisationNumber: NullishType(Type.String()),
});
export const ListSupplierInvoiceSchema = Type.Object({
    id: Type.String(),
    accountType: NullishType(Type.String()),
    invoiceNumber: NullishType(Type.String()),
    status: NullishType(Type.Enum(SupplierInvoiceStatusType)),
    supplier: NullishType(Type.String()),
    totalAmount: NullishType(Type.Number()),
    invoiceDate: NullishType(Type.String()),
    dueDate: NullishType(Type.String()),
    approver: NullishType(Type.String()),
    supplierInvoiceNumber: NullishType(Type.String()),
});
export const ListSupplierInvoicesResponseSchema = Type.Array(ListSupplierInvoiceSchema);
export const SupplierInvoiceSplitRowSchema = Type.Object({
    accountNumber: Type.Number(),
    accountName: Type.String(),
    projectId: NullishType(Type.String()),
    projectName: NullishType(Type.String()),
    amount: Type.Number(),
    ataNumber: NullishType(Type.Number()),
    ataName: NullishType(Type.String()),
});
export const SupplierInvoiceRowSchema = Type.Object({
    id: Type.String(),
    accountNumber: Type.Number(),
    accountName: Type.String(),
    projectId: NullishType(Type.String()),
    projectName: NullishType(Type.String()),
    // 21@tag:vera-2.5:not-here - this should not change
    debit: Type.Number(),
    credit: Type.Number(),
    ataNumber: NullishType(Type.Number()),
    ataName: NullishType(Type.String()),
    splitRows: Type.Array(SupplierInvoiceSplitRowSchema),
});
export const GetSupplierInvoiceParamsSchema = Type.Object({
    id: Type.String(),
});
export const GetSupplierInvoiceSchema = Type.Object({
    id: Type.String(),
    status: NullishType(Type.Enum(SupplierInvoiceStatusType)),
    invoiceNumber: NullishType(Type.String()),
    supplierId: NullishType(Type.String()),
    supplierName: NullishType(Type.String()),
    organisationNumber: NullishType(Type.String()),
    supplierInvoiceNumber: NullishType(Type.String()),
    address: NullishType(Type.String()),
    zipCode: NullishType(Type.String()),
    city: NullishType(Type.String()),
    bankGiro: NullishType(Type.String()),
    postGiro: NullishType(Type.String()),
    invoiceDate: NullishType(Type.String()),
    dueDate: NullishType(Type.String()),
    termsOfPayment: NullishType(Type.String()),
    vatType: NullishType(Type.Enum(VatType)),
    vat: NullishType(Type.Number()),
    notes: NullishType(Type.String()),
    rows: Type.Array(SupplierInvoiceRowSchema),
    project: Type.String(),
});
export const UpdateSupplierInvoiceParamsSchema = Type.Object({
    id: Type.String(),
});
export const UpdateSupplierInvoiceBodySchema = Type.Object({
    notes: NullishType(Type.String()),
    project: NullishType(Type.String()),
    rows: Type.Array(SupplierInvoiceRowSchema),
});
export const SupplierInvoiceFileSchema = Type.Object({
    fileId: Type.String(),
    name: Type.String(),
    blob: Type.String(),
});
export const GetSupplierInvoiceFilesSchema = Type.Array(SupplierInvoiceFileSchema);
export const GetAllSupplierInvoicesToReviewResponseSchema = Type.Array(Type.Object({
    projectId: Type.String(),
    invoiceId: Type.String(),
}));
export const SupplierInvoiceNotificationTypeSchema = Type.Union([
    Type.Literal('PENDING_REVIEW'),
    Type.Literal('CONTESTED'),
    Type.Literal('PARKED'),
]);
export const GetSupplierInvoiceNotificationsResponseSchema = Type.Array(Type.Object({
    invoiceId: Type.String(),
    projectId: Type.String(),
    type: SupplierInvoiceNotificationTypeSchema,
}));
export const PutSupplierInvoiceProjectBodySchema = Type.Object({
    projectId: Type.String(),
});
